export default class IdExtractor{

    /**
     * The method is used when the ID is the last element in the url,
     * and is preceded by resources names (injection, batch, post, edit-post)
     * If a new resource name appears, it should be added to the array of possiblePrefix
     * @returns {string|null}
     */
    static extractIdAtUrlEnd(){
        const parts = window.location.href.replace(/([?#].*)$/, '')
            .split("/").filter(Boolean);
        const possiblePrefix = ["injection", "batch", "post", "edit-post"];
        if (parts.length < 6 || !possiblePrefix.includes(parts[parts.length - 2])) return null;
        return parts[parts.length - 1];
    }

    /**
     * The method is used when the ID is the penultimate element of the url, and last element is word "edit" or "report"
     * If a new word appears, it should be added to the array of validSuffixes
     * @returns {string|null}
     */
    static extractIdBeforeSuffix(){
        const parts = window.location.href.replace(/([?#].*)$/, '')
            .split("/").filter(Boolean);
        const validSuffixes  = ["edit", "report"];
        if (parts.length < 7 || !validSuffixes.includes(parts[parts.length - 1])) return null;
        return parts[parts.length - 2];
    }
}